<template>
	<div class="pt-2">
		<CommonFlame :title="title">
			<v-row no-gutters justify="end">
				<v-btn @click="savePreparation()" color="secondary">
					<v-icon class="mr-1"> mdi-content-save </v-icon>
					保存
				</v-btn>
			</v-row>
			<div class="mt-4">
				<table width="100%" class="show-dialog-table">
					<tbody>
						<template v-if="!$vuetify.breakpoint.xs">
							<tr>
								<th width="15%">工事名</th>
								<td width="35%">XXXXX</td>
								<th width="15%">製番</th>
								<td width="35%">XXXXX</td>
							</tr>
							<tr>
								<th width="15%">出張先</th>
								<td width="35%">XXXXX</td>
								<th width="15%">作業責任者</th>
								<td width="35%">XXXXX</td>
							</tr>
						</template>
						<template v-else>
							<tr>
								<th width="30%">工事名</th>
								<td width="70%">XXXXXX</td>
							</tr>
							<tr>
								<th width="30%">製番</th>
								<td width="70%">XXXXXX</td>
							</tr>
							<tr>
								<th width="30%">出張先</th>
								<td width="70%">XXXXXX</td>
							</tr>
							<tr>
								<th width="30%">作業責任者</th>
								<td width="70%">XXXXXX</td>
							</tr>
						</template>
					</tbody>
				</table>
			</div>
			<div class="mt-4">
				<v-row no-gutters>
					<v-col md="6" cols="12" class="pr-md-2">
						<v-sheet elevation="0">
							<div class="table-container">
								<table width="100%" class="show-dialog-table" :style="minWidth(560)">
									<tbody>
										<tr>
											<th width="20%">ロットNo.</th>
											<th width="30%">名称・材料</th>
											<th width="10%">規格</th>
											<th width="10%">単位</th>
											<th width="30%">持ち出し数量(合計量)</th>
										</tr>
										<tr v-for="(material, i) in materials" :key="i">
											<td><v-text-field v-model="TODO" dense outlined hide-details /></td>
											<td>XXXXXXXXX</td>
											<td>XX</td>
											<td>XX</td>
											<td><v-text-field v-model="TODO" dense outlined hide-details /></td>
										</tr>
									</tbody>
								</table>
							</div>
							<v-btn class="mt-2" color="secondary" @click="openAddDialog('materials')">
								<v-icon class="mr-1">mdi-plus</v-icon>
								材料を追加
							</v-btn>
						</v-sheet>
						<v-sheet elevation="0" class="mt-4">
							<div class="table-container">
								<table width="100%" class="show-dialog-table" :style="minWidth(430)">
									<tbody>
										<tr>
											<th width="30%">検査機器類</th>
											<th width="25%">機器管理番号</th>
											<th width="20%">数量</th>
											<th width="25%">登録機器番号</th>
										</tr>
										<tr v-for="(inspection_instrument, i) in inspection_instruments" :key="i">
											<td>XXXXXXX</td>
											<td><v-text-field v-model="TODO" dense outlined hide-details /></td>
											<td><v-text-field v-model="TODO" dense outlined hide-details /></td>
											<td><v-text-field v-model="TODO" dense outlined hide-details /></td>
										</tr>
									</tbody>
								</table>
							</div>
							<v-btn
								class="mt-4"
								color="secondary"
								@click="openAddDialog('inspection_instruments')"
							>
								<v-icon class="mr-1">mdi-plus</v-icon>
								検査機器類を追加
							</v-btn>
						</v-sheet>
						<v-sheet elevation="0" class="mt-4">
							<div class="table-container">
								<table width="100%" class="show-dialog-table" :style="minWidth(400)">
									<tbody>
										<tr>
											<th width="30%">消耗品</th>
											<th width="25%">規格</th>
											<th width="20%">単位</th>
											<th width="25%">持出し数量</th>
										</tr>
										<tr v-for="(consumption_article, i) in consumption_articles" :key="i">
											<td>XXXXXXX</td>
											<td>XXXXX</td>
											<td>XX</td>
											<td><v-text-field v-model="TODO" dense outlined hide-details /></td>
										</tr>
									</tbody>
								</table>
							</div>
							<v-btn class="mt-2" color="secondary" @click="openAddDialog('consumption_articles')">
								<v-icon class="mr-1">mdi-plus</v-icon>
								消耗品を追加
							</v-btn>
						</v-sheet>
					</v-col>
					<v-col md="6" cols="12" class="pl-md-2 mt-4 mt-md-0">
						<v-sheet elevation="0">
							<div class="table-container">
								<table width="100%" class="show-dialog-table" :style="minWidth(450)">
									<tbody>
										<tr>
											<th width="50%" colspan="2">一般工具類等</th>
											<th width="15%">規格</th>
											<th width="15%">単位</th>
											<th width="20%">持出し数量</th>
										</tr>
										<tr v-for="(tool, i) in tools" :key="i">
											<td width="20%">XXXX</td>
											<td width="30%">XXXX</td>
											<td>XX</td>
											<td>XX</td>
											<td><v-text-field v-model="TODO" dense outlined hide-details /></td>
										</tr>
									</tbody>
								</table>
							</div>
							<v-btn class="mt-2" color="secondary" @click="openAddDialog('tools')">
								<v-icon class="mr-1">mdi-plus</v-icon>
								一般工具類等を追加
							</v-btn>
						</v-sheet>
						<v-sheet elevation="0" class="mt-4">
							<div class="table-container">
								<table width="100%" class="show-dialog-table" :style="minWidth(400)">
									<tbody>
										<tr>
											<th width="40%">リース品</th>
											<th width="30%">仕様</th>
											<th width="30%">持ち出し数量</th>
										</tr>
										<tr v-for="(lease_product, i) in lease_products" :key="i">
											<td>XXXXXXX</td>
											<td>XXXX</td>
											<td><v-text-field v-model="TODO" dense outlined hide-details /></td>
										</tr>
									</tbody>
								</table>
							</div>
							<v-btn class="mt-2" color="secondary" @click="openAddDialog('lease_products')">
								<v-icon class="mr-1">mdi-plus</v-icon>
								リース品を追加
							</v-btn>
						</v-sheet>
					</v-col>
				</v-row>
			</div>
			<ConstructionMaterialAddDialog
				:dialog.sync="addDialog"
				:category="selectedCategory"
				:categories="categories"
				@add-item="addItem"
			/>
		</CommonFlame>
	</div>
</template>

<script>
import axios from "axios"
import authenticate from "../../helper/authenticate"
import errorHandling from "../../helper/errorHandling"
import common from "../../helper/common"
import CommonFlame from "../shared/CommonFlame.vue"
import ConstructionMaterialAddDialog from "./components/ConstructionMaterialAddDialog.vue"

export default {
	components: {
		CommonFlame,
		ConstructionMaterialAddDialog,
	},
	data() {
		return {
			title: "材料準備入力",
			id: this.$route.params.id,
			TODO: null,
			materials: [{}],
			inspection_instruments: [{}],
			consumption_articles: [{}],
			tools: [{}],
			lease_products: [{}],
			categories: [
				{ name: "材料", id: "materials" },
				{ name: "検査機器類", id: "inspection_instruments" },
				{ name: "消耗品", id: "consumption_articles" },
				{ name: "一般工具類等", id: "tools" },
				{ name: "リース品", id: "lease_products" },
			], // 仮 DB から取得の可能性あり
			addDialog: false,
			selectedCategory: null,
			common,
		}
	},

	mounted() {
		// this.fetchConstructionPreparation()
	},
	methods: {
		fetchConstructionPreparation() {
			const headers = authenticate.setHeader()
			const url = `/erp/v1/constructions/construction_preparations/${this.id}/edit`
			axios
				.get(url, {
					headers,
				})
				.then((res) => {
					// TODO
				})
				.catch((err) => {
					errorHandling.errorResponse(err)
				})
		},
		savePreparation() {
			const headers = authenticate.setHeader()
			const url = `/erp/v1/constructions/construction_preparations/${this.id}`
			const params = {}
			axios
				.put(url, params, {
					headers,
				})
				.then((res) => {
					// TODO
				})
				.catch((err) => {
					errorHandling.errorResponse(err)
				})
		},
		openAddDialog(category) {
			this.selectedCategory = category
			this.addDialog = true
		},
		addItem(category, item) {
			this[category].push(item)
		},
		minWidth(num) {
			return { "min-width": num + "px" }
		},
	},
}
</script>

<style lang="scss" scoped>
th {
	background-color: whitesmoke;
	border-right: 1px solid white;
	font-weight: bold;
	padding: 4px;
}
td {
	border-bottom: 1px solid whitesmoke;
	padding: 4px;
	border-right: 1px solid whitesmoke;
	&:first-child {
		border-left: 1px solid whitesmoke;
	}
}
</style>